var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 85,
    viewBox: "0 0 84 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50016 17.5C2.2085 17.5 0.333496 19.375 0.333496 21.6667V75.8334C0.333496 80.4167 4.0835 84.1667 8.66683 84.1667H62.8335C65.1252 84.1667 67.0002 82.2917 67.0002 80C67.0002 77.7084 65.1252 75.8334 62.8335 75.8334H12.8335C10.5418 75.8334 8.66683 73.9584 8.66683 71.6667V21.6667C8.66683 19.375 6.79183 17.5 4.50016 17.5ZM75.3335 0.833374H25.3335C20.7502 0.833374 17.0002 4.58337 17.0002 9.16671V59.1667C17.0002 63.75 20.7502 67.5 25.3335 67.5H75.3335C79.9168 67.5 83.6668 63.75 83.6668 59.1667V9.16671C83.6668 4.58337 79.9168 0.833374 75.3335 0.833374ZM67.0002 38.3334H33.6668C31.3752 38.3334 29.5002 36.4584 29.5002 34.1667C29.5002 31.875 31.3752 30 33.6668 30H67.0002C69.2918 30 71.1668 31.875 71.1668 34.1667C71.1668 36.4584 69.2918 38.3334 67.0002 38.3334ZM50.3335 55H33.6668C31.3752 55 29.5002 53.125 29.5002 50.8334C29.5002 48.5417 31.3752 46.6667 33.6668 46.6667H50.3335C52.6252 46.6667 54.5002 48.5417 54.5002 50.8334C54.5002 53.125 52.6252 55 50.3335 55ZM67.0002 21.6667H33.6668C31.3752 21.6667 29.5002 19.7917 29.5002 17.5C29.5002 15.2084 31.3752 13.3334 33.6668 13.3334H67.0002C69.2918 13.3334 71.1668 15.2084 71.1668 17.5C71.1668 19.7917 69.2918 21.6667 67.0002 21.6667Z",
    fill: "#2980B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageIcon);
export default __webpack_public_path__ + "static/media/PageIcon.3983b6e0524902c097ed0c07c684cf86.svg";
export { ForwardRef as ReactComponent };